import { Crown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PremiumBadgeProps {
  tier: string | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const PremiumBadge = ({ tier, className, size = 'md' }: PremiumBadgeProps) => {
  if (!tier) return null;

  const isElite = tier === 'elite';
  const isPro = tier === 'pro';

  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center',
        isElite && 'text-warning',
        isPro && 'text-primary',
        className
      )}
      title={`TAM ${isElite ? 'Elite' : 'Pro'} Member`}
    >
      <Crown className={cn(sizeClasses[size], 'drop-shadow-md')} />
    </span>
  );
};

export default PremiumBadge;